import { createApp } from "vue";
import App from "./App.vue";
import router from "./routes";
import store from "./store";
import "./assets/style/global.css";

import Antd from "ant-design-vue";
import "ant-design-vue/dist/reset.css";

import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";

// import * as filters from './filters' // 全局filter

// 加载过滤器
// Object.keys(filters).forEach(key => {
//     app.config.globalProperties.$filters[key] = filters[key]
// })
/* 全局指令:水波纹 */
import waves from "@/directive/waves/index.js";

const app = createApp(App);

app.use(router);
app.use(store);
app.use(Antd);
app.use(ElementPlus);

// Register all Element Plus icons globally
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

app.directive("waves", waves);

app.mount("#app");
